
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class BrandAmbassadorGrid extends Serenity.EntityGrid<BrandAmbassadorRow, any> {
        protected getColumnsKey() { return BrandAmbassadorColumns.columnsKey; }
        protected getDialogType() { return BrandAmbassadorDialog; }
        protected getIdProperty() { return BrandAmbassadorRow.idProperty; }
        protected getInsertPermission() { return BrandAmbassadorRow.insertPermission; }
        protected getLocalTextPrefix() { return BrandAmbassadorRow.localTextPrefix; }
        protected getService() { return BrandAmbassadorService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}